
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ProjectGallery from '@/components/feature/ProjectGallery';
import { commercialProjects } from '@/mocks/projects';

export default function Commercial() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Main Content */}
      <main className="pt-20">
        {/* Page Header */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h1 className="text-3xl md:text-4xl font-light tracking-wider text-gray-800 uppercase mb-8">
                {t('commercial')}
              </h1>
            </div>
          </div>
        </section>

        {/* Projects Gallery - Full Width */}
        <section className="pb-16">
          <div className="w-full">
            <ProjectGallery projects={commercialProjects} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
